import React, {useEffect}  from "react";
import { Row, Col, Button } from "antd";
import styled from "styled-components";
import { Link } from "react-router-dom";
import textileservices from "../image/textileservices.jpg";
import Imexpservices from "../image/Im-expservices.jpg";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

const MainWrapper = styled.div`
  background: #1f3c3d;
  padding: 40px 10%;
`;

const CardWrapper = styled.div`
  position: relative;
  background-image: url(${textileservices});
    no-repeat center;
  background-size: cover;
  border-radius: 16px;
  width: 100%;
  overflow: hidden;
  height: 253px;

  /* Black Overlay */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(0 0 0 / 45%); /* Adjust opacity as needed */
    border-radius: 16px;
  }
`;

const ContentBox = styled.div`
  color: white;
  padding: 20px;
  text-align: center;
  position: relative; /* Ensure content appears above overlay */
  z-index: 1;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin: 5px 0;
`;

const Price = styled.p`
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
`;

const ShopButton = styled(Button)`
  background: #00b368;
  color: white;
  font-weight: bold;
  &:hover {
    background: #009956;
  }
`;

const ProductImage = styled.img`
  width: 300px;
  height: 200px;
  position: relative;
  z-index: 1;
`;

const Section5 = () => {
  const Functionscrooll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    AOS.init({ duration: 2000 }); // Initialize AOS with a duration of 1000ms
  }, []);
  return (
    <MainWrapper>
      <Row justify="center">
        <Col xs={24} sm={24} md={20} >
        <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 1.0 }}
                className="motion-div"
                data-aos="fade-up" 
              >
          <CardWrapper>
            <br />
            <br />
            <Row gutter={[16, 16]} align="middle">
              {/* Left Column - Product Info */}
              <Col xs={24} md={24} lg={8} xl={8}>
                <ContentBox>
                  {/* <p>trending</p> */}
                  <Title>Nexus Wealth Services</Title>
                  {/* <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    with desktop publishing software like Aldus PageMaker
                    including versions of Lorem Ipsum
                  </p> */}
                  <br />
                  <br />
                  <br />
                  <Link to="/contact" onClick={Functionscrooll}>
                    <ShopButton type="primary">Contact →</ShopButton>
                  </Link>
                </ContentBox>
              </Col>

              {/* Right Column - Product Image */}
              {/* <Col xs={24} md={18} style={{ textAlign: "left" }}>
                <ProductImage src="" alt="demo" />
              </Col> */}
            </Row>
            <br />
            <br />
          </CardWrapper>
          </motion.div>
        </Col>
      </Row>
    </MainWrapper>
  );
};

export default Section5;
